/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { CoreApiConfiguration } from '../core-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ActionOriginResponse as ApiActionOriginResponse } from '../models/api/action-origin-response';
import { ActionStatusResponse as ApiActionStatusResponse } from '../models/api/action-status-response';
import { ActionTagResponse as ApiActionTagResponse } from '../models/api/action-tag-response';
import { ActionTypeResponse as ApiActionTypeResponse } from '../models/api/action-type-response';
import { BoardSettingsResponse as ApiBoardSettingsResponse } from '../models/api/board-settings-response';
import { ListActionOriginResponse as ApiListActionOriginResponse } from '../models/api/list-action-origin-response';
import { ListActionStatusesResponse as ApiListActionStatusesResponse } from '../models/api/list-action-statuses-response';
import { ListActionTagsResponse as ApiListActionTagsResponse } from '../models/api/list-action-tags-response';
import { ListActionTypesResponse as ApiListActionTypesResponse } from '../models/api/list-action-types-response';
import { createActionOrigin } from '../fn/board-settings/create-action-origin';
import { CreateActionOrigin$Params } from '../fn/board-settings/create-action-origin';
import { createActionStatus } from '../fn/board-settings/create-action-status';
import { CreateActionStatus$Params } from '../fn/board-settings/create-action-status';
import { createActionTag } from '../fn/board-settings/create-action-tag';
import { CreateActionTag$Params } from '../fn/board-settings/create-action-tag';
import { createActionType } from '../fn/board-settings/create-action-type';
import { CreateActionType$Params } from '../fn/board-settings/create-action-type';
import { deleteActionOrigin } from '../fn/board-settings/delete-action-origin';
import { DeleteActionOrigin$Params } from '../fn/board-settings/delete-action-origin';
import { deleteActionStatus } from '../fn/board-settings/delete-action-status';
import { DeleteActionStatus$Params } from '../fn/board-settings/delete-action-status';
import { deleteActionTag } from '../fn/board-settings/delete-action-tag';
import { DeleteActionTag$Params } from '../fn/board-settings/delete-action-tag';
import { deleteActionType } from '../fn/board-settings/delete-action-type';
import { DeleteActionType$Params } from '../fn/board-settings/delete-action-type';
import { getActionOrigin } from '../fn/board-settings/get-action-origin';
import { GetActionOrigin$Params } from '../fn/board-settings/get-action-origin';
import { getActionStatus } from '../fn/board-settings/get-action-status';
import { GetActionStatus$Params } from '../fn/board-settings/get-action-status';
import { getActionTag } from '../fn/board-settings/get-action-tag';
import { GetActionTag$Params } from '../fn/board-settings/get-action-tag';
import { getActionType } from '../fn/board-settings/get-action-type';
import { GetActionType$Params } from '../fn/board-settings/get-action-type';
import { getBoardSettings } from '../fn/board-settings/get-board-settings';
import { GetBoardSettings$Params } from '../fn/board-settings/get-board-settings';
import { listActionOrigins } from '../fn/board-settings/list-action-origins';
import { ListActionOrigins$Params } from '../fn/board-settings/list-action-origins';
import { listActionStatuses } from '../fn/board-settings/list-action-statuses';
import { ListActionStatuses$Params } from '../fn/board-settings/list-action-statuses';
import { listActionTags } from '../fn/board-settings/list-action-tags';
import { ListActionTags$Params } from '../fn/board-settings/list-action-tags';
import { listActionTypes } from '../fn/board-settings/list-action-types';
import { ListActionTypes$Params } from '../fn/board-settings/list-action-types';
import { updateActionOrigin } from '../fn/board-settings/update-action-origin';
import { UpdateActionOrigin$Params } from '../fn/board-settings/update-action-origin';
import { updateActionStatus } from '../fn/board-settings/update-action-status';
import { UpdateActionStatus$Params } from '../fn/board-settings/update-action-status';
import { updateActionTag } from '../fn/board-settings/update-action-tag';
import { UpdateActionTag$Params } from '../fn/board-settings/update-action-tag';
import { updateActionType } from '../fn/board-settings/update-action-type';
import { UpdateActionType$Params } from '../fn/board-settings/update-action-type';
import { updateBoardSettings } from '../fn/board-settings/update-board-settings';
import { UpdateBoardSettings$Params } from '../fn/board-settings/update-board-settings';

@Injectable({ providedIn: 'root' })
export class BoardSettingsService extends BaseService {
  constructor(config: CoreApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getBoardSettings()` */
  static readonly GetBoardSettingsPath = '/v1/boards/{boardId}/board-settings';

  /**
   * Get BoardSettings.
   *
   * Get a specific boardSettings
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBoardSettings()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBoardSettings$Response(
    params: GetBoardSettings$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiBoardSettingsResponse>> {
    return getBoardSettings(this.http, this.rootUrl, params, context);
  }

  /**
   * Get BoardSettings.
   *
   * Get a specific boardSettings
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBoardSettings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBoardSettings(params: GetBoardSettings$Params, context?: HttpContext): Observable<ApiBoardSettingsResponse> {
    return this.getBoardSettings$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiBoardSettingsResponse>): ApiBoardSettingsResponse => r.body)
    );
  }

  /** Path part for operation `updateBoardSettings()` */
  static readonly UpdateBoardSettingsPath = '/v1/boards/{boardId}/board-settings';

  /**
   * Update BoardSettings.
   *
   * Update a specific BoardSettings
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateBoardSettings()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateBoardSettings$Response(
    params: UpdateBoardSettings$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<string>> {
    return updateBoardSettings(this.http, this.rootUrl, params, context);
  }

  /**
   * Update BoardSettings.
   *
   * Update a specific BoardSettings
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateBoardSettings$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateBoardSettings(params: UpdateBoardSettings$Params, context?: HttpContext): Observable<string> {
    return this.updateBoardSettings$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `listActionOrigins()` */
  static readonly ListActionOriginsPath = '/v1/boards/{boardId}/board-settings/action-origins';

  /**
   * List ActionOrigins.
   *
   * List all action origins
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listActionOrigins()` instead.
   *
   * This method doesn't expect any request body.
   */
  listActionOrigins$Response(
    params: ListActionOrigins$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiListActionOriginResponse>> {
    return listActionOrigins(this.http, this.rootUrl, params, context);
  }

  /**
   * List ActionOrigins.
   *
   * List all action origins
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listActionOrigins$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listActionOrigins(params: ListActionOrigins$Params, context?: HttpContext): Observable<ApiListActionOriginResponse> {
    return this.listActionOrigins$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiListActionOriginResponse>): ApiListActionOriginResponse => r.body)
    );
  }

  /** Path part for operation `createActionOrigin()` */
  static readonly CreateActionOriginPath = '/v1/boards/{boardId}/board-settings/action-origins';

  /**
   * Create ActionOrigin.
   *
   * Create an action origin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createActionOrigin()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createActionOrigin$Response(
    params: CreateActionOrigin$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiActionOriginResponse>> {
    return createActionOrigin(this.http, this.rootUrl, params, context);
  }

  /**
   * Create ActionOrigin.
   *
   * Create an action origin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createActionOrigin$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createActionOrigin(params: CreateActionOrigin$Params, context?: HttpContext): Observable<ApiActionOriginResponse> {
    return this.createActionOrigin$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiActionOriginResponse>): ApiActionOriginResponse => r.body)
    );
  }

  /** Path part for operation `getActionOrigin()` */
  static readonly GetActionOriginPath = '/v1/boards/{boardId}/board-settings/action-origins/{id}';

  /**
   * Get ActionOrigin.
   *
   * Get a specific action origin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getActionOrigin()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActionOrigin$Response(
    params: GetActionOrigin$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiActionOriginResponse>> {
    return getActionOrigin(this.http, this.rootUrl, params, context);
  }

  /**
   * Get ActionOrigin.
   *
   * Get a specific action origin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getActionOrigin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActionOrigin(params: GetActionOrigin$Params, context?: HttpContext): Observable<ApiActionOriginResponse> {
    return this.getActionOrigin$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiActionOriginResponse>): ApiActionOriginResponse => r.body)
    );
  }

  /** Path part for operation `deleteActionOrigin()` */
  static readonly DeleteActionOriginPath = '/v1/boards/{boardId}/board-settings/action-origins/{id}';

  /**
   * Delete ActionOrigin.
   *
   * Delete an action origin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteActionOrigin()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteActionOrigin$Response(
    params: DeleteActionOrigin$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<string>> {
    return deleteActionOrigin(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete ActionOrigin.
   *
   * Delete an action origin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteActionOrigin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteActionOrigin(params: DeleteActionOrigin$Params, context?: HttpContext): Observable<string> {
    return this.deleteActionOrigin$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `updateActionOrigin()` */
  static readonly UpdateActionOriginPath = '/v1/boards/{boardId}/board-settings/action-origins/{id}';

  /**
   * Update ActionOrigin.
   *
   * Update an action origin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateActionOrigin()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateActionOrigin$Response(
    params: UpdateActionOrigin$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiActionOriginResponse>> {
    return updateActionOrigin(this.http, this.rootUrl, params, context);
  }

  /**
   * Update ActionOrigin.
   *
   * Update an action origin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateActionOrigin$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateActionOrigin(params: UpdateActionOrigin$Params, context?: HttpContext): Observable<ApiActionOriginResponse> {
    return this.updateActionOrigin$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiActionOriginResponse>): ApiActionOriginResponse => r.body)
    );
  }

  /** Path part for operation `listActionStatuses()` */
  static readonly ListActionStatusesPath = '/v1/boards/{boardId}/board-settings/action-statuses';

  /**
   * List ActionStatuses.
   *
   * List actionStatuses
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listActionStatuses()` instead.
   *
   * This method doesn't expect any request body.
   */
  listActionStatuses$Response(
    params: ListActionStatuses$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiListActionStatusesResponse>> {
    return listActionStatuses(this.http, this.rootUrl, params, context);
  }

  /**
   * List ActionStatuses.
   *
   * List actionStatuses
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listActionStatuses$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listActionStatuses(
    params: ListActionStatuses$Params,
    context?: HttpContext
  ): Observable<ApiListActionStatusesResponse> {
    return this.listActionStatuses$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiListActionStatusesResponse>): ApiListActionStatusesResponse => r.body)
    );
  }

  /** Path part for operation `createActionStatus()` */
  static readonly CreateActionStatusPath = '/v1/boards/{boardId}/board-settings/action-statuses';

  /**
   * Create ActionStatus.
   *
   * Create an actionStatus
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createActionStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createActionStatus$Response(
    params: CreateActionStatus$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiActionStatusResponse>> {
    return createActionStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * Create ActionStatus.
   *
   * Create an actionStatus
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createActionStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createActionStatus(params: CreateActionStatus$Params, context?: HttpContext): Observable<ApiActionStatusResponse> {
    return this.createActionStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiActionStatusResponse>): ApiActionStatusResponse => r.body)
    );
  }

  /** Path part for operation `getActionStatus()` */
  static readonly GetActionStatusPath = '/v1/boards/{boardId}/board-settings/action-statuses/{id}';

  /**
   * Get ActionStatus.
   *
   * Get a specific actionStatus
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getActionStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActionStatus$Response(
    params: GetActionStatus$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiActionStatusResponse>> {
    return getActionStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * Get ActionStatus.
   *
   * Get a specific actionStatus
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getActionStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActionStatus(params: GetActionStatus$Params, context?: HttpContext): Observable<ApiActionStatusResponse> {
    return this.getActionStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiActionStatusResponse>): ApiActionStatusResponse => r.body)
    );
  }

  /** Path part for operation `deleteActionStatus()` */
  static readonly DeleteActionStatusPath = '/v1/boards/{boardId}/board-settings/action-statuses/{id}';

  /**
   * Delete ActionStatus.
   *
   * Delete an actionStatus
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteActionStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteActionStatus$Response(
    params: DeleteActionStatus$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<string>> {
    return deleteActionStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete ActionStatus.
   *
   * Delete an actionStatus
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteActionStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteActionStatus(params: DeleteActionStatus$Params, context?: HttpContext): Observable<string> {
    return this.deleteActionStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `updateActionStatus()` */
  static readonly UpdateActionStatusPath = '/v1/boards/{boardId}/board-settings/action-statuses/{id}';

  /**
   * Update ActionStatus.
   *
   * Update an actionStatus
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateActionStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateActionStatus$Response(
    params: UpdateActionStatus$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<string>> {
    return updateActionStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * Update ActionStatus.
   *
   * Update an actionStatus
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateActionStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateActionStatus(params: UpdateActionStatus$Params, context?: HttpContext): Observable<string> {
    return this.updateActionStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `listActionTags()` */
  static readonly ListActionTagsPath = '/v1/boards/{boardId}/board-settings/action-tags';

  /**
   * List ActionTags.
   *
   * List ActionTags
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listActionTags()` instead.
   *
   * This method doesn't expect any request body.
   */
  listActionTags$Response(
    params: ListActionTags$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiListActionTagsResponse>> {
    return listActionTags(this.http, this.rootUrl, params, context);
  }

  /**
   * List ActionTags.
   *
   * List ActionTags
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listActionTags$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listActionTags(params: ListActionTags$Params, context?: HttpContext): Observable<ApiListActionTagsResponse> {
    return this.listActionTags$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiListActionTagsResponse>): ApiListActionTagsResponse => r.body)
    );
  }

  /** Path part for operation `createActionTag()` */
  static readonly CreateActionTagPath = '/v1/boards/{boardId}/board-settings/action-tags';

  /**
   * Create ActionTag.
   *
   * Create an ActionTag
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createActionTag()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createActionTag$Response(
    params: CreateActionTag$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiActionTagResponse>> {
    return createActionTag(this.http, this.rootUrl, params, context);
  }

  /**
   * Create ActionTag.
   *
   * Create an ActionTag
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createActionTag$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createActionTag(params: CreateActionTag$Params, context?: HttpContext): Observable<ApiActionTagResponse> {
    return this.createActionTag$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiActionTagResponse>): ApiActionTagResponse => r.body)
    );
  }

  /** Path part for operation `getActionTag()` */
  static readonly GetActionTagPath = '/v1/boards/{boardId}/board-settings/action-tags/{id}';

  /**
   * Get ActionTag.
   *
   * Get a specific ActionTag
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getActionTag()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActionTag$Response(
    params: GetActionTag$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiActionTagResponse>> {
    return getActionTag(this.http, this.rootUrl, params, context);
  }

  /**
   * Get ActionTag.
   *
   * Get a specific ActionTag
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getActionTag$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActionTag(params: GetActionTag$Params, context?: HttpContext): Observable<ApiActionTagResponse> {
    return this.getActionTag$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiActionTagResponse>): ApiActionTagResponse => r.body)
    );
  }

  /** Path part for operation `deleteActionTag()` */
  static readonly DeleteActionTagPath = '/v1/boards/{boardId}/board-settings/action-tags/{id}';

  /**
   * Delete ActionTag.
   *
   * Delete an ActionTag
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteActionTag()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteActionTag$Response(
    params: DeleteActionTag$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<string>> {
    return deleteActionTag(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete ActionTag.
   *
   * Delete an ActionTag
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteActionTag$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteActionTag(params: DeleteActionTag$Params, context?: HttpContext): Observable<string> {
    return this.deleteActionTag$Response(params, context).pipe(map((r: StrictHttpResponse<string>): string => r.body));
  }

  /** Path part for operation `updateActionTag()` */
  static readonly UpdateActionTagPath = '/v1/boards/{boardId}/board-settings/action-tags/{id}';

  /**
   * Update ActionTag.
   *
   * Update an ActionTag
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateActionTag()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateActionTag$Response(
    params: UpdateActionTag$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<string>> {
    return updateActionTag(this.http, this.rootUrl, params, context);
  }

  /**
   * Update ActionTag.
   *
   * Update an ActionTag
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateActionTag$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateActionTag(params: UpdateActionTag$Params, context?: HttpContext): Observable<string> {
    return this.updateActionTag$Response(params, context).pipe(map((r: StrictHttpResponse<string>): string => r.body));
  }

  /** Path part for operation `listActionTypes()` */
  static readonly ListActionTypesPath = '/v1/boards/{boardId}/board-settings/action-types';

  /**
   * List ActionTypes.
   *
   * List ActionTypes
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listActionTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  listActionTypes$Response(
    params: ListActionTypes$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiListActionTypesResponse>> {
    return listActionTypes(this.http, this.rootUrl, params, context);
  }

  /**
   * List ActionTypes.
   *
   * List ActionTypes
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listActionTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listActionTypes(params: ListActionTypes$Params, context?: HttpContext): Observable<ApiListActionTypesResponse> {
    return this.listActionTypes$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiListActionTypesResponse>): ApiListActionTypesResponse => r.body)
    );
  }

  /** Path part for operation `createActionType()` */
  static readonly CreateActionTypePath = '/v1/boards/{boardId}/board-settings/action-types';

  /**
   * Create ActionType.
   *
   * Create an ActionType
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createActionType()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createActionType$Response(
    params: CreateActionType$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiActionTypeResponse>> {
    return createActionType(this.http, this.rootUrl, params, context);
  }

  /**
   * Create ActionType.
   *
   * Create an ActionType
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createActionType$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createActionType(params: CreateActionType$Params, context?: HttpContext): Observable<ApiActionTypeResponse> {
    return this.createActionType$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiActionTypeResponse>): ApiActionTypeResponse => r.body)
    );
  }

  /** Path part for operation `getActionType()` */
  static readonly GetActionTypePath = '/v1/boards/{boardId}/board-settings/action-types/{id}';

  /**
   * Get ActionType.
   *
   * Get a specific ActionType
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getActionType()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActionType$Response(
    params: GetActionType$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiActionTypeResponse>> {
    return getActionType(this.http, this.rootUrl, params, context);
  }

  /**
   * Get ActionType.
   *
   * Get a specific ActionType
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getActionType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActionType(params: GetActionType$Params, context?: HttpContext): Observable<ApiActionTypeResponse> {
    return this.getActionType$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiActionTypeResponse>): ApiActionTypeResponse => r.body)
    );
  }

  /** Path part for operation `deleteActionType()` */
  static readonly DeleteActionTypePath = '/v1/boards/{boardId}/board-settings/action-types/{id}';

  /**
   * Delete ActionType.
   *
   * Delete an ActionType
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteActionType()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteActionType$Response(
    params: DeleteActionType$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<string>> {
    return deleteActionType(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete ActionType.
   *
   * Delete an ActionType
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteActionType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteActionType(params: DeleteActionType$Params, context?: HttpContext): Observable<string> {
    return this.deleteActionType$Response(params, context).pipe(map((r: StrictHttpResponse<string>): string => r.body));
  }

  /** Path part for operation `updateActionType()` */
  static readonly UpdateActionTypePath = '/v1/boards/{boardId}/board-settings/action-types/{id}';

  /**
   * Update ActionType.
   *
   * Update an ActionType
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateActionType()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateActionType$Response(
    params: UpdateActionType$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<string>> {
    return updateActionType(this.http, this.rootUrl, params, context);
  }

  /**
   * Update ActionType.
   *
   * Update an ActionType
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateActionType$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateActionType(params: UpdateActionType$Params, context?: HttpContext): Observable<string> {
    return this.updateActionType$Response(params, context).pipe(map((r: StrictHttpResponse<string>): string => r.body));
  }
}
